export const fetchDownloads = async (form, offset) => {
  const data = new FormData(form);
  data.set("tx_downloads_list[offset]", offset.toString());
  return await fetch(form.action, {
    method: form.method,
    body: data
  }).then((res) => res.json());
};
